export const VIETNAM_CODE = 'vietnam';
